/*
 * Copyright (c) 2020 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */

class Ref {
  public tid: number;
  public tvertex: number;

  constructor() {
    this.tid = 0;
    this.tvertex = 0;
  }
}

export default Ref;
